import { Body, Container, Header } from './style';

const SEOContentSkeletonLoader = () => {
  return (
    <Container>
      <Header />
      <Body />
    </Container>
  );
};

export default SEOContentSkeletonLoader;
